import React from 'react';
import Popup from 'reactjs-popup';
import { Button} from 'react-bootstrap';
import '../styles/PopUps.css';

//Attempted to make this component as reusable as possible
export const ConfirmModal = (props) => {
    const closeModal = () =>
        props.handleClose();

    function handleClick() {
        props.handleAccept();
    }

    return (
        <><Popup open={props.isOpen} modal closeOnDocumentClick={false}>
            {<>
                <div className='confirm-modal'>
                    <h4 style={{ margin: "10px" }}>{props.message}</h4>
                </div>
                <div className="confirm-modal-buttons">
                    <Button style={{ marginLeft: "20px" }} onClick={() => { handleClick() }}>Yes</Button>
                    <Button style={{ marginLeft: "20px" }} onClick={() => {
                        closeModal();
                    }}>
                        No
                    </Button>
                </div>
            </>}
        </Popup></>
    );
}